import { useCallback } from "react";

import { useToast } from "@vega-core/components/Toast/useToast";
import { m } from "@vega-core/paraglide/messages";
import { isTruthy } from "@vega-core/utils/isTruthy";

type UseClipboardProps = {
  name: string;
  withToast?: boolean;
};

export const useClipboard = ({ name, withToast }: UseClipboardProps) => {
  const showToast = useToast();

  const copy = useCallback(
    async (value: string) => {
      try {
        await navigator.clipboard.writeText(value);

        if (isTruthy(withToast)) {
          showToast({
            variant: "success",
            title: m.clipboard_copy_successTitle(),
            description: m.clipboard_copy_successDescription({
              name,
            }),
          });
        }
      } catch (err) {
        showToast({
          title: m.clipboard_copy_errorTitle(),
          description:
            err instanceof Error && err.message
              ? err.message
              : m.clipboard_copy_errorDescription(),
          variant: "destructive",
        });
      }
    },
    [name, showToast, withToast],
  );

  return { copy };
};
